export default __webpack_public_path__ + "static/media/MarkW05-Light.c71ef788.woff2";